<template>
    <div>
        <div>
            <div class="row mb-8">
                <div class="col-12 col-md-4 d-flex justify-content-start">
                    <v-card-title>
                        {{ $t('clients.clients') }}
                    </v-card-title>
                </div>
                <div class="col-12 col-md-8 d-flex justify-content-end gap-2 ">
                    <genericBtnComponent @click="openFilterDialog" svg="4" Title="" class="ml-2" />
                </div>
            </div>
        </div>
        <v-card flat>
            <ClientsList ref="invoiceListRef" :showFilterDialog="showFilterDialog"
                @open-filter-dialog="openFilterDialog" />
        </v-card>
    </div>
</template>
<script>
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue"
import ClientsList from "./ClientsList.vue";

export default {
    components: {
        ClientsList,
        genericBtnComponent
    },
    mounted() {
        document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.clients');
    },
    data: () => ({
        showFilterDialog: false,
    }),
    methods: {
        openFilterDialog(newValue) {
            this.showFilterDialog = newValue;
        },
        closeFilterDialog() {
            this.showFilterDialog = false;
        },
    },
};
</script>
<style scoped>
.v-card-title {
    color: #001e50;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}
</style>